export class EndpointEnumerator {
    constructor(obj) {
        for (const key in obj) {
            this[key] = obj[key];
        }
        return Object.freeze(this);
    }
    has = (key) => {
        return this.hasOwnProperty(key);
    }
}



// WEBPACK FOOTER //
// ./src/scripts/api/endpoints/types/endpoint-enumerator.js